export enum Environment {
  DEV = 'development',
  STAGING = 'staging',
  E2E = 'e2e',
  PROD = 'production'
}

/* eslint-disable max-len */
export const getEnvironment = (): Environment => {
  if (process.env.NODE_ENV === 'development') {
    return Environment.DEV;
  }
  if (process.env.TARGET_ENV === 'staging') {
    return Environment.STAGING;
  }

  if (process.env.TARGET_ENV === 'e2e') {
    return Environment.E2E;
  }

  return Environment.PROD;
};

export const ENV = getEnvironment();

// List of base config.
const baseConfig: { [key: string]: { [key: string]: string } } = {
  // Graphql endpoint.
  GRAPHQL_URL: {
    staging: 'https://api-stage.epochapp.com/graphql',
    e2e: 'https://api-e2e.epochapp.com/graphql',
    development: 'http://localhost:5000/graphql',
    production: 'https://api.epochapp.com/graphql',
    default: 'http://localhost:5000/graphql'
  },
  // API endpoint.
  API_URL: {
    staging: 'https://api-stage.epochapp.com/api/v1',
    e2e: 'https://api-e2e.epochapp.com/api/v1',
    production: 'https://api.epochapp.com/api/v1',
    default: 'http://localhost:5000/api/v1'
  },
  WEBSOCKET_URL: {
    production: 'wss://chat.epochapp.com/ws',
    staging: 'wss://chat.epochapp.com/ws',
    default: 'ws://localhost:8000/ws'
  },
  WEBSOCKET_STAGE_URL: {
    production: 'wss://chattest.epochapp.com/ws',
    staging: 'wss://chattest.epochapp.com/ws',
    default: 'ws://localhost:8000/ws'
  },
  // GraphQL credentials mode for handling cookies and authentication
  GRAPHQL_CREDENTIALS_MODE: {
    staging: 'include',
    e2e: 'include',
    development: 'include',
    production: 'include', // Changed from 'same-origin' for separated frontend/backend
    default: 'include'
  }
};

/**
 * Grab config value.
 * @param {*} key
 * @returns
 */
export const getConfig = (key: string): string => {
  if (ENV && baseConfig[key][ENV]) {
    return baseConfig[key][ENV];
  }

  return baseConfig[key].default;
};
